import { render, staticRenderFns } from "./KnowledgeCenterDetail.vue?vue&type=template&id=1a1a614c&scoped=true"
import script from "./KnowledgeCenterDetail.vue?vue&type=script&lang=js"
export * from "./KnowledgeCenterDetail.vue?vue&type=script&lang=js"
import style0 from "../../assets/css/group_dashboard/all_messages.css?vue&type=style&index=0&id=1a1a614c&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a1a614c",
  null
  
)

export default component.exports